import { FC, ReactNode } from 'react';

const BidButtonsGroup: FC<{ children?: ReactNode }> = ({ children }) => (
  <div className="mb-15px mt-5 flex items-center justify-between gap-2.5 [&>button:last-child]:ml-auto">
    {children}
  </div>
);

export { BidButtonsGroup };
